/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"informationBlock":"informationBlock_ouVy3","title":"title_gQxXa","content":"content_rVS-w"};